import React from 'react'
import type { LinkProps } from 'react-router'
import { Link } from 'react-router'

interface SidebarLinkProps extends Omit<LinkProps, 'to'> {
  href: string
}

export const SidebarLink = React.forwardRef<HTMLAnchorElement, SidebarLinkProps>(
  ({ href, ...props }, ref) => <Link to={href} {...props} ref={ref} />,
)

SidebarLink.displayName = 'SidebarLink'
